// PhoneInput.jsx
import InputMask from "react-input-mask";
import React from "react";
import {
  fieldContainer,
  fieldControlBase,
  fieldControlError,
  fieldErrorText,
  fieldLabel,
} from "./inputTheme";

function selectMask(v = "", fallback = "(99) 99999-9999") {
  const digits = (v || "").replace(/\D/g, "");
  // se tiver 11 dígitos (celular), usa 99999; se 10 (fixo), usa 9999
  return digits.length === 10 ? "(99) 99999-9999" : fallback;
}

const PhoneInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = "text",
  mask = "AUTO", // AUTO = escolhe pela quantidade de dígitos
  required,
  ...props
}) => {
  const appliedMask =
    mask === "AUTO"
      ? selectMask(value)
      : mask === "DEFAULT"
      ? "(99) 99999-9999"
      : "(99)999999999";

  return (
    <div className={fieldContainer}>
      {label && (
        <label htmlFor={name} className={fieldLabel}>
          {label}
        </label>
      )}

      <InputMask
        id={name}
        name={name}
        type={type}
        className={`${fieldControlBase} ${error ? fieldControlError : ""}`}
        placeholder=""
        value={value ?? ""}
        onChange={onChange}
        onBlur={onBlur}
        mask={appliedMask}
        maskChar=""
        alwaysShowMask={false}
        {...props}
      />

      {error && <small className={fieldErrorText}>{error}</small>}
    </div>
  );
};

export default PhoneInput;
